import {Backdrop, Box, Button, CircularProgress, Dialog, MenuItem, Stack, TextField, Typography} from '@mui/material'
import CalculateIcon from '@mui/icons-material/Calculate';
import Header from './Header';
import { useEffect, useState, useContext } from 'react';
import { Context } from "../App";
import { API } from "../conf";
import Alerte from './alerte';

function Home() {
  const { updateConnect, eglise,setEglise } = useContext(Context)
  const user = JSON.parse(sessionStorage.getItem('user'))
  const [loading, setLoad] = useState(true)
  const [eglises, setEglises] = useState([])
  const [egliseId, setEgliseId] = useState('')
  const [can_verse, setVers] = useState(0)
  const [have_rapport, setRapport] = useState(true)
  const [eglise_solde, setSolde] = useState()
  const [petite_caisse, setPC] = useState()
  const [msg, setMsg] = useState('')
  const [alerts, setAlerts] = useState([])

  useEffect(()=>{
    if(!user) {
      updateConnect(false)
    }
  },[])

  useEffect(()=>{
    async function get_eglises() {
      fetch(API.concat(`/eglises/by/${JSON.stringify(user.eglises?.length>0 ? {number:{$in: user.eglises}}:user.level>=4?{isUnion: false}:{isFederation: false, isUnion: false})}`), {
        method:'GET',
        headers:{
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
      }).then(async(response) => {
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
          sessionStorage.clear()
          updateConnect(false)
        }else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
          }
          if (response.status === 200) {
            const json = await response.json()
            setEglises(json.filter(item=>!item.isFederation))
            setLoad(false)
          }
        }
      })
    }
    if(!user) return
    if (user?.level>2||(user.eglises.length>0&&eglises.length!==user.eglises.length&&eglises.slice().sort().join()!==user.eglises.slice().sort().join())) {
      get_eglises()      
    } else {
      setLoad(false)
    }
  },[updateConnect, user?.eglises, eglises])

  useEffect(()=>{
    function check_possible_action() {
      fetch(API.concat(`/dons/simple/by/${JSON.stringify({eglise: eglise?.number, $or: [{is_preverse: false}, {is_cloture: true}]})}`), {
        method:'GET',
        headers:{
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
      }).then(async(response) => {
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
          sessionStorage.clear()
          updateConnect(false)
        }else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
          }
          if (response.status === 200) {
            const dons = await response.json()
            setVers(dons.filter(don => !don.is_preverse).length)
          }
        }
      })

      fetch(API.concat(`/eglises/${eglise.number}/have_cloture`), {
        method:'GET',
        headers:{
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
      }).then(async(response) => {
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
          sessionStorage.clear()
          updateConnect(false)
        }else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
          }
          if (response.status === 200) {
            const have_cloture = await response.json()
            setRapport(have_cloture)
          }
        }
      })
    }

    function get_eglise_solde() {
      fetch(API.concat(`/comptes/by/${JSON.stringify({eglise: eglise?.number})}`), {
        method:'GET',
        headers:{
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
      }).then(async(response) => {
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
          sessionStorage.clear()
          updateConnect(false)
        }else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
          }
          if (response.status === 200) {
            const comptes = await response.json()
            setSolde(comptes.find(cpt=> cpt.type==='liaison')?.solde??0);
            setPC(comptes.find(cpt=> cpt.type==='petite-caisse'));
            if (eglise&&!eglise.isFederation&&comptes.reduce((tt,cpt)=>tt+cpt.percent,0)<100) {
              setMsg('Attention! Répartition du budget incomplète.')
            } else if(eglise&&!eglise.isFederation&&comptes.filter(cpt=>!['petite-caisse', 'liaison'].includes(cpt.type)).reduce((tt,cpt)=>tt+cpt.solde,0)!==comptes.find(cpt=>cpt.type==='liaison').solde) {
              setMsg('Attention! Solde compte principal différent du solde total des comptes.')
            } else setMsg('')
            setLoad(false)
          }
        }
      })
    }

    function getAlerts() {
      fetch(API.concat(`/alerts/${JSON.stringify({eglises: eglise.number, is_active: true})}`), {
        method:'GET',
        headers:{
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
      }).then(async(response) => {
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
          sessionStorage.clear()
          updateConnect(false)
        }else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
          }
          if (response.status === 200) {
            const alerts = await response.json()
            setAlerts(alerts)
          }
        }
      })
    }

    if (eglise!==''&&eglise.number) {
      get_eglise_solde()
      getAlerts()
      if(!eglise?.isFederation)check_possible_action()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eglise])

  useEffect(()=>{
    if (egliseId!=='') {
      setEglise(eglises.find(el=>el._id===egliseId)??egliseId)      
    }
  },[egliseId])

  useEffect(()=>{
    if(eglises.some(el=>el._id===eglise._id)) {
      setEgliseId(eglise._id)
    }
  },[eglises])

  if (!user?.access) return <div></div>
  return (
    <div style={{display:'flex', flexDirection:'column', height:'100vh'}}>
      <Header/>
      <Box display='flex'>
        <Box display='flex' flex={1} rowGap={1} flexDirection='column' sx={{alignItems:'start', padding:'15px'}}>
          {alerts.sort((a, b)=>b.level-a.level).map(alert => (
            <Alerte key={alert._id} alert={alert} />
          ))}
        </Box>
        <Box display='flex' flex={1} flexDirection='column' sx={{alignItems:'end'}} >
          <Box display='flex' flexDirection='row' justifyContent='end' alignItems='start' padding='15px'>
            {eglise!==''&&eglise!=='indifferent'&& !loading&&<Box sx={{ backgroundColor:'verdigris.main', padding:'20px', borderRadius:5}} >
              <Typography variant='h4' textAlign='center'>Solde: {eglise_solde?.toFixed(2)} €</Typography>
              <Typography variant='h5' textAlign='center'>Petite-Caisse: {petite_caisse?.solde?.toFixed(2)} €</Typography>
              <Typography variant='h5' textAlign='center' >Dons à verser: {can_verse}</Typography>
            </Box>}
          </Box>
          {user.access.includes("/comptes/consultation")&&eglise!==''&&<Button variant='outlined' sx={{ alignSelf:'end', marginRight:'15px'}} href='/comptes/consultation'>Consulter Comptes</Button>}
          {/* <Button variant='outlined' sx={{ alignSelf:'end', marginRight:'15px', marginTop:'15px'}} href='/comptes/consultation'>Synchroniser</Button> */}
        </Box>
      </Box>
      {(user.eglises.length>1||user.level>2)&&<Box display='flex' flex={1} flexDirection='column' alignItems='center' marginTop='5px' marginBottom='20px'>
        <Typography variant='h5' marginBottom='15px'>Choisissez une église</Typography>
        <TextField select required sx={{width:'35%', minWidth:'300px'}} value={egliseId} onChange={e=>setEgliseId(e.target.value)}>
          <MenuItem value='indifferent'>Indifférent</MenuItem>
          {eglises.sort((a,b)=>(a.nom+' '+a.commune)<(b.nom+' '+b.commune)?-1:1).map(item=><MenuItem key={item._id} value={item._id} style={{textTransform:'capitalize'}}>{item.nom} - {item.commune}</MenuItem>)}
        </TextField>
      </Box>}

      <Stack direction='column' spacing={5} sx={{alignSelf:'center', display:'flex', justifyContent:'center', height:'100%', paddingBottom:'50px'}}>
        {eglise!==''&&<Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}>
          {user.access.includes("/recettes/enregistrement-des-fonds")&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/recettes/enregistrement-des-fonds">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Recettes</Typography>
          </Button>}
          {user.access.includes("/caisse")&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/caisse">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>caisse</Typography>
          </Button>}
          {user.access.includes("/versements/enregistrement")&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/versements/enregistrement">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Versements</Typography>
          </Button>}
          {user.access.includes('/depenses/enregistrement')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/depenses/enregistrement">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Dépenses</Typography>
          </Button>}
          {user.access.includes("/caisse/versements")&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/caisse/versements">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"} textAlign='center'>Versements Caisse</Typography>
          </Button>}
          {user.access.includes("/versements/banque")&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/versements/banque">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"} textAlign='center'>Versements Banque</Typography>
          </Button>}
        </Stack>}

        {eglise!==''&&<Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}>
          {user.access.includes('/cloture')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/cloture'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Clôture</Typography>
          </Button>}
          {user.access.includes('/rapports')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} disabled={!have_rapport} href='/rapports'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Rapport</Typography>
          </Button>}
        </Stack>}

        {eglise!==''&&<Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}> 
          {user.access.includes('/journal/dons')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/dons'>
            <CalculateIcon fontSize='large'/>
            <Typography textAlign='center' fontSize={12} position={"bottom"}>Journal des recettes</Typography>
          </Button>}
          {user.access.includes('/journal/versements')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/versements'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"} textAlign='center'>Journal des versements</Typography>
          </Button>}
          {user.access.includes('/journal/depenses')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/depenses'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"} align='center'>Journal des dépenses</Typography>
          </Button>}
          {user.access.includes('/journal/petite-caisse')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/petite-caisse'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} align='center' position={"bottom"}>Journal de petite caisse</Typography>
          </Button>}
          {user.access.includes('/journal/global')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/global'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"} textAlign={'center'}>Journal global</Typography>
          </Button>}
          {user.access.includes('/web&bornes')&&<Button variant='contained' disabled style={{width:100, height:100, flexDirection:'column'}}>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Dons web/bornes</Typography>
          </Button>}
        </Stack>}
        
        {msg!==''&&<Typography variant='subtitle1' color='carmine.main' align='center' marginTop={1}>{msg}</Typography>}
        <Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}>
          {user.access.includes('/donateurs')&&eglise!==''&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/donateurs'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Donateurs</Typography>
          </Button>}
          {user.access.includes('/comptes')&&eglise!==''&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/comptes'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Comptes</Typography>
          </Button>}
          {user.access.includes('/users')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/users'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Utilisateurs</Typography>
          </Button>}
          {user.access.includes('/eglises')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/eglises'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Églises</Typography>
          </Button>}
          {user.access.includes('/alertes')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/alertes'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Alertes</Typography>
          </Button>}
        </Stack>
        
        {['/export/ebp','/dada-base'].some(ac=>user.access.includes(ac))&&
        <Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}>
          {user.access.includes('/export/ebp')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/export/ebp'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} align='center' position={"bottom"}>export EBP</Typography>
          </Button>}
          {user.access.includes('/dada-base')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/dada-base'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>DB</Typography>
          </Button>}
        </Stack>}
      </Stack>
      
      {/* <Dialog open={open} onClose={()=>setOpen(false)} maxWidth='xs' >
        <Typography variant='subtitle1' align='center' margin='15px'>Clôturer l'année {year} et créer et ouvrir l'année {next_year}</Typography>
        <Stack direction='row' spacing={2} alignSelf='end' margin='15px'>
          <Button onClick={()=>setOpen(false)}>non</Button>
          <Button variant='contained'>oui</Button>
        </Stack>
      </Dialog> */}

      <Backdrop open={loading}><CircularProgress/></Backdrop>
    </div>
  );
}

export default Home;
